import React from 'react';

const CardIcon = ({ icon }) => (
  <div className="card-body-icon">
    <i className={`fa-fw fas ` + icon}></i>
  </div>
);

export default CardIcon;
